import produce from "immer";
import { types } from "./constants";

export const initialState = {
  products: [],
  selectedProduct: null,
  isLoading: true,
  isCreatingOrder: false,
  isCapturingOrder: false,
};

const purchaseReducer = (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      case types.GET_PRODUCTS_REQUEST:
        draft.isLoading = true;
        break;
      case types.GET_PRODUCTS_SUCCESS:
        draft.products = payload.data;
        draft.isLoading = false;
        break;
      case types.GET_PRODUCTS_FAIL:
        draft.isLoading = false;
        break;
      case types.CREATE_ORDER_REQUEST:
        draft.isCreatingOrder = true;
        break;
      case types.CREATE_ORDER_SUCCESS:
        draft.isCreatingOrder = false;
        break;
      case types.CREATE_ORDER_FAIL:
        draft.isCreatingOrder = false;
        break;
      case types.CAPTURE_ORDER_REQUEST:
        draft.isCapturingOrder = true;
        break;
      case types.CAPTURE_ORDER_SUCCESS:
        draft.isCapturingOrder = false;
        break;
      case types.CAPTURE_ORDER_FAIL:
        draft.isCapturingOrder = false;
        break;
      case types.SELECT_PRODUCT:
        draft.selectedProduct = payload.product;
        break;
      case types.CLEAR_SELECTED_PRODUCT:
        draft.selectedProduct = null;
        break;
      case "LOGOUT_SUCCESS":
        draft.products = [];
        draft.selectedProduct = null;
        draft.isLoading = true;
        draft.isCreatingOrder = false;
        draft.isCapturingOrder = false;
        break;
      default:
        break;
    }
  });

export default purchaseReducer;
